export default "__VITE_ASSET__0485ad2f__"